export const tableWrapperStyles = {
  overflowX: "auto", // Enables horizontal scrolling
  whiteSpace: "nowrap",
};
